import { UNTITLED_ISSUE_TITLE, INDEX_FALLBACK } from "@overmap-ai/common"
import type { IFuseOptions } from "fuse.js"

import type { IssueAndIdentifiers } from "../typings"

export const ISSUE_FUSE_OPTIONS: IFuseOptions<IssueAndIdentifiers> = {
	isCaseSensitive: false,
	threshold: 0.2,
	keys: [
		{
			name: "index",
			weight: 0.5,
			getFn: ({ issue }) => issue.index?.toString() ?? INDEX_FALLBACK,
		},
		{
			name: "title",
			weight: 0.5,
			getFn: ({ issue }) => issue.title || UNTITLED_ISSUE_TITLE,
		},
		{
			name: "identifiers",
			weight: 2,
			getFn: ({ identifierValues }) => identifierValues.map(({ value }) => value),
		},
	],
}
